import {defineStore} from 'pinia'

const STORE_NAME = 'offsetQuery'

export const useOffsetQueryStore= defineStore("offsetQueryStore", {
    state: () => {
        return {
        }
    },
    getters: {
        // toggleCustomerOrderLightInfoMode : (state) => {
        //     return !state.lightMode
        // }
    },
    actions: {
        inventoryQuery(searchFilter){
            let searchFilterKeys = Object.keys(searchFilter);
            searchFilterKeys.forEach((key) => {
                if(searchFilter[key] === ''){
                    searchFilter[key] = null;
                }
            });

            return new Promise((resolve, reject) => {
                axios.post('/materials', searchFilter)
                .then(response =>{
                    resolve(response.data);
                })
                .catch(err=>{
                    console.log(err);
                    reject(err);
                })
            });
        },

        logEntryQuery(searchFilter){
            return new Promise((resolve, reject) => {
                axios.post('/logfiles/list', searchFilter)
                .then(response =>{
                    resolve(response.data);
                })
                .catch(err=>{
                    console.log(err);
                    reject(err);
                })
            });
        },
        inventoryExportQuery(searchFilter){
          let searchFilterKeys = Object.keys(searchFilter);
          searchFilterKeys.forEach((key) => {
              if(searchFilter[key] === ''){
                  searchFilter[key] = null;
              }
          })
          return new Promise((resolve, reject) => {
              axios.post('/materials/export', searchFilter)
              .then(response =>{
                  // console.log('offsetStore');
                  // console.log(response.data);
                  resolve(response.data);
              })
              .catch(err=>{
                  console.log(err);
                  reject(err);
              })
          });
      },
    },    

});